import { render, staticRenderFns } from "./SubNavigation.vue?vue&type=template&id=5340819e&"
import script from "./SubNavigation.vue?vue&type=script&lang=ts&"
export * from "./SubNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./SubNavigation.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports